<template>
    <van-popup v-model="showAlert" class="cusSer_box">
        <div class="cusSer_main">
            <p>{{isQR ? '关注公众号，及时接收活动信息' : text}}</p>
            <img :src="officialImg">
            <div class="tips">{{isQR ? '长按识别关注公众号' : '长按添加客服微信号'}}</div>
        </div>
        <div class="closeBox">
            <img class="close" @click="hideDialog" :src="require('@/common/images/activeTools/close.png')" alt="">
        </div>
    </van-popup>
</template>

<script>
export default {
    name: 'OfficialAlert',
    data() {
        return {
            showAlert: false,
            isService: 1,
            officialImg: '',
            isQR: 1,
            text: ''
        }
    },
    methods: {
        showDialog(img, text, qr) {
            this.officialImg = img
            this.isQR = qr
            this.text = text
            this.showAlert = true
        },
        hideDialog() {
            this.showAlert = false
        }
    }
}
</script>

<style lang="scss">
.cusSer_box {
    text-align: center;
    background: transparent;
    .cusSer_main {
        width: 5.2rem;
        height: 5.64rem;
        background: white;
        border-radius: 0.13rem;
        p {
            font-size: 0.32rem;
            color: #333333;
            padding: 0.3rem 0;
        }
        img {
            width: 3.96rem;
            height: 3.96rem;
            display: inline-block;
        }
        .tips {
            font-size: .26rem;
            color: #333;
            margin-top: .2rem;
        }
    }
    .closeBox {
        width: 0.6rem;
        height: 0.6rem;
        margin: 0.4rem auto;
        .close {
            width: 0.6rem;
            height: 0.6rem;
        }
    }
}
</style>


